// extracted by mini-css-extract-plugin
export default {"card":"card__-4bc1365d","row":"row__-4bc1365d","price":"price__-4bc1365d"};